export const biohacker02 = {
    "Систолическое артериальное давление": {
        "units": "Ед. рт.ст.",
        "values": [
            {
                "panel_id": 10009,
                "made_at": "2016-12-01T00:00:00Z",
                "value": 111.99,
                "warning_bottom_edge": 110,
                "warning_top_edge": 129
            },
            {
                "panel_id": 10010,
                "made_at": "2017-02-04T00:00:00Z",
                "value": 117.63,
                "warning_bottom_edge": 110,
                "warning_top_edge": 129
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 127.54,
                "warning_bottom_edge": 110,
                "warning_top_edge": 129
            },
            {
                "panel_id": 10012,
                "made_at": "2018-03-16T00:00:00Z",
                "value": 118.82,
                "warning_bottom_edge": 110,
                "warning_top_edge": 129
            },
            {
                "panel_id": 10013,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 111.94,
                "warning_bottom_edge": 110,
                "warning_top_edge": 129
            },
            {
                "panel_id": 10014,
                "made_at": "2018-03-30T00:00:00Z",
                "value": 121.37,
                "warning_bottom_edge": 110,
                "warning_top_edge": 129
            },
            {
                "panel_id": 10015,
                "made_at": "2018-04-01T00:00:00Z",
                "value": 126.45,
                "warning_bottom_edge": 110,
                "warning_top_edge": 129
            }
        ]
    },
    "Диастолическое артериальное давление": {
        "units": "Ед. рт.ст.",
        "values": [
            {
                "panel_id": 10009,
                "made_at": "2016-12-01T00:00:00Z",
                "value": 116.28,
                "warning_bottom_edge": 70,
                "warning_top_edge": 79
            },
            {
                "panel_id": 10010,
                "made_at": "2017-02-04T00:00:00Z",
                "value": 78.15,
                "warning_bottom_edge": 70,
                "warning_top_edge": 79
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 75.61,
                "warning_bottom_edge": 70,
                "warning_top_edge": 79
            },
            {
                "panel_id": 10012,
                "made_at": "2018-03-16T00:00:00Z",
                "value": 76.62,
                "warning_bottom_edge": 70,
                "warning_top_edge": 79
            },
            {
                "panel_id": 10013,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 102.2,
                "warning_bottom_edge": 70,
                "warning_top_edge": 79
            },
            {
                "panel_id": 10014,
                "made_at": "2018-03-30T00:00:00Z",
                "value": 74.91,
                "warning_bottom_edge": 70,
                "warning_top_edge": 79
            },
            {
                "panel_id": 10015,
                "made_at": "2018-04-01T00:00:00Z",
                "value": 78.38,
                "warning_bottom_edge": 70,
                "warning_top_edge": 79
            }
        ]
    },
    "Холестерин": {
        "units": "ммоль/л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2016-04-01T00:00:00Z",
                "value": 3.4000000000000004,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 4.263,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 2.8122,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 2.891,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 3.5788,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 4.776199999999999,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 5.510400000000001,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10009,
                "made_at": "2018-03-16T00:00:00Z",
                "value": 5.0838,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10010,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 5.725,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-30T00:00:00Z",
                "value": 6.7635000000000005,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10012,
                "made_at": "2018-04-01T00:00:00Z",
                "value": 4.2116999999999996,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 3.6270000000000002,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 1.8998,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10015,
                "made_at": "2018-07-04T00:00:00Z",
                "value": 4.347,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 3.6454999999999997,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 2.43,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 2.0272,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 1.655,
                "warning_bottom_edge": 0,
                "warning_top_edge": 5.2
            }
        ]
    },
    "ЛПВП": {
        "units": "ммоль/л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2016-04-01T00:00:00Z",
                "value": 0.79,
                "warning_bottom_edge": 1.01,
                "warning_top_edge": 2.49
            },
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 1.75,
                "warning_bottom_edge": 1.01,
                "warning_top_edge": 2.49
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 2.06,
                "warning_bottom_edge": 1.01,
                "warning_top_edge": 2.49
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 2.11,
                "warning_bottom_edge": 1.01,
                "warning_top_edge": 2.49
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 1.6965,
                "warning_bottom_edge": 0,
                "warning_top_edge": 2.49
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 2.05,
                "warning_bottom_edge": 1.01,
                "warning_top_edge": 2.49
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 2.36,
                "warning_bottom_edge": 1.01,
                "warning_top_edge": 2.49
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 2.31,
                "warning_bottom_edge": 1.01,
                "warning_top_edge": 2.49
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 1.39,
                "warning_bottom_edge": 1.01,
                "warning_top_edge": 2.49
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 2.23,
                "warning_bottom_edge": 1.01,
                "warning_top_edge": 2.49
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 0.62,
                "warning_bottom_edge": 1.01,
                "warning_top_edge": 2.49
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 1.3,
                "warning_bottom_edge": 1.01,
                "warning_top_edge": 2.49
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 1.21,
                "warning_bottom_edge": 1.01,
                "warning_top_edge": 2.49
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 1.54,
                "warning_bottom_edge": 1.01,
                "warning_top_edge": 2.49
            }
        ]
    },
    "ЛПНП": {
        "units": "ммоль/л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2016-04-01T00:00:00Z",
                "value": 2.2161,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 2.04,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 2.5212,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 2.1854999999999998,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 1.7120000000000002,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 1.0808,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 2.9502,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10009,
                "made_at": "2018-03-16T00:00:00Z",
                "value": 2.511,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10010,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 3.3384,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-30T00:00:00Z",
                "value": 1.9276,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10012,
                "made_at": "2018-04-01T00:00:00Z",
                "value": 1.825,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 1.5364,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 0.9968000000000001,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10015,
                "made_at": "2018-07-04T00:00:00Z",
                "value": 2.5276,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 1.0436999999999999,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 1.7555999999999998,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 1.0692000000000002,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 1.9536,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.8
            }
        ]
    },
    "Триглицериды": {
        "units": "ммоль/л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2016-04-01T00:00:00Z",
                "value": 0.7004,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 0.47,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 0.8190000000000001,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 0.6808000000000001,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 0.8580000000000001,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 0.7973,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 0.4536,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 0.48360000000000003,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 0.3286,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 0.899,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 0.8232,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 0.72,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            }
        ]
    },
    "Паратгормон": {
        "units": "пмоль/л",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 9.13,
                "warning_bottom_edge": 2.0,
                "warning_top_edge": 9.4
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 6.12,
                "warning_bottom_edge": 2.0,
                "warning_top_edge": 9.4
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 8.45,
                "warning_bottom_edge": 2.0,
                "warning_top_edge": 9.4
            },
            {
                "panel_id": 10009,
                "made_at": "2018-03-16T00:00:00Z",
                "value": 5.03,
                "warning_bottom_edge": 2.0,
                "warning_top_edge": 9.4
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 9.35,
                "warning_bottom_edge": 2.0,
                "warning_top_edge": 9.4
            },
            {
                "panel_id": 10012,
                "made_at": "2018-03-30T00:00:00Z",
                "value": 5.97,
                "warning_bottom_edge": 2.0,
                "warning_top_edge": 9.4
            },
            {
                "panel_id": 10013,
                "made_at": "2018-04-01T00:00:00Z",
                "value": 3.46,
                "warning_bottom_edge": 2.0,
                "warning_top_edge": 9.4
            }
        ]
    },
    "Кальций": {
        "units": "ммоль/л",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 1.42,
                "warning_bottom_edge": 2.1,
                "warning_top_edge": 2.99
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 2.34,
                "warning_bottom_edge": 2.1,
                "warning_top_edge": 2.99
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 3.87,
                "warning_bottom_edge": 2.1,
                "warning_top_edge": 2.99
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 2.67,
                "warning_bottom_edge": 2.1,
                "warning_top_edge": 2.99
            }
        ]
    },
    "Глюкоза": {
        "units": "ммоль/л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2016-04-01T00:00:00Z",
                "value": 5.13,
                "warning_bottom_edge": 4.1,
                "warning_top_edge": 6.0
            },
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 2.64,
                "warning_bottom_edge": 4.1,
                "warning_top_edge": 6.0
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 4.54,
                "warning_bottom_edge": 4.1,
                "warning_top_edge": 6.0
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 3.38,
                "warning_bottom_edge": 4.1,
                "warning_top_edge": 6.0
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 2.88,
                "warning_bottom_edge": 4.1,
                "warning_top_edge": 6.0
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 2.28,
                "warning_bottom_edge": 4.1,
                "warning_top_edge": 6.0
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 5.5,
                "warning_bottom_edge": 4.1,
                "warning_top_edge": 6.0
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 4.31,
                "warning_bottom_edge": 4.1,
                "warning_top_edge": 6.0
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 4.8,
                "warning_bottom_edge": 4.1,
                "warning_top_edge": 6.0
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 4.15,
                "warning_bottom_edge": 4.1,
                "warning_top_edge": 6.0
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 4.69,
                "warning_bottom_edge": 4.1,
                "warning_top_edge": 6.0
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 5.68,
                "warning_bottom_edge": 4.1,
                "warning_top_edge": 6.0
            }
        ]
    },
    "Инсулин": {
        "units": "мкМЕ/мл",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2016-04-01T00:00:00Z",
                "value": 2.7,
                "warning_bottom_edge": 0,
                "warning_top_edge": 10.5
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 3.9899999999999998,
                "warning_bottom_edge": 0,
                "warning_top_edge": 10.5
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 6.566000000000001,
                "warning_bottom_edge": 0,
                "warning_top_edge": 10.5
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 4.646,
                "warning_bottom_edge": 0,
                "warning_top_edge": 10.5
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 3.7439999999999998,
                "warning_bottom_edge": 0,
                "warning_top_edge": 10.5
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 6.417,
                "warning_bottom_edge": 0,
                "warning_top_edge": 10.5
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 5.166,
                "warning_bottom_edge": 0,
                "warning_top_edge": 10.5
            }
        ]
    },
    "HOMA-IR": {
        "units": null,
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2016-04-01T00:00:00Z",
                "value": 0.5,
                "warning_bottom_edge": 0,
                "warning_top_edge": 2.7
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 1.38,
                "warning_bottom_edge": 0,
                "warning_top_edge": 2.7
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 0.9570000000000001,
                "warning_bottom_edge": 0,
                "warning_top_edge": 2.7
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 1.19,
                "warning_bottom_edge": 0,
                "warning_top_edge": 2.7
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 0.672,
                "warning_bottom_edge": 0,
                "warning_top_edge": 2.7
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 1.84,
                "warning_bottom_edge": 0,
                "warning_top_edge": 2.7
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 1.0912,
                "warning_bottom_edge": 0,
                "warning_top_edge": 2.7
            }
        ]
    },
    "Т3 свободный": {
        "units": "пмоль/л",
        "values": [
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 5.55,
                "warning_bottom_edge": 4.09,
                "warning_top_edge": 6.8
            },
            {
                "panel_id": 10009,
                "made_at": "2018-03-16T00:00:00Z",
                "value": 5.03,
                "warning_bottom_edge": 4.09,
                "warning_top_edge": 6.8
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 5.41,
                "warning_bottom_edge": 4.09,
                "warning_top_edge": 6.8
            },
            {
                "panel_id": 10012,
                "made_at": "2018-03-30T00:00:00Z",
                "value": 5.34,
                "warning_bottom_edge": 4.09,
                "warning_top_edge": 6.8
            },
            {
                "panel_id": 10013,
                "made_at": "2018-04-01T00:00:00Z",
                "value": 4.77,
                "warning_bottom_edge": 4.09,
                "warning_top_edge": 6.8
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 2.93,
                "warning_bottom_edge": 4.09,
                "warning_top_edge": 6.8
            },
            {
                "panel_id": 10015,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 5.21,
                "warning_bottom_edge": 4.09,
                "warning_top_edge": 6.8
            }
        ]
    },
    "Т4 свободный": {
        "units": "пмоль/л",
        "values": [
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 15.26,
                "warning_bottom_edge": 13.0,
                "warning_top_edge": 21.4
            },
            {
                "panel_id": 10009,
                "made_at": "2018-03-16T00:00:00Z",
                "value": 19.13,
                "warning_bottom_edge": 13.0,
                "warning_top_edge": 21.4
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 25.66,
                "warning_bottom_edge": 13.0,
                "warning_top_edge": 21.4
            },
            {
                "panel_id": 10012,
                "made_at": "2018-03-30T00:00:00Z",
                "value": 17.7,
                "warning_bottom_edge": 13.0,
                "warning_top_edge": 21.4
            },
            {
                "panel_id": 10013,
                "made_at": "2018-04-01T00:00:00Z",
                "value": 25.9,
                "warning_bottom_edge": 13.0,
                "warning_top_edge": 21.4
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 14.81,
                "warning_bottom_edge": 13.0,
                "warning_top_edge": 21.4
            },
            {
                "panel_id": 10015,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 17.77,
                "warning_bottom_edge": 13.0,
                "warning_top_edge": 21.4
            }
        ]
    },
    "АТ-ТГ": {
        "units": "МЕ/мл",
        "values": [
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 0.522,
                "warning_bottom_edge": 0,
                "warning_top_edge": 40
            },
            {
                "panel_id": 10009,
                "made_at": "2018-03-16T00:00:00Z",
                "value": 0.9900000000000001,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 0.7103999999999999,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 0.3835,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 0.7705,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 0.35280000000000006,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 0.6324,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 0.8617999999999999,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 0.7315999999999999,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 0.41440000000000005,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 0.318,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.7
            }
        ]
    },
    "АЛТ": {
        "units": "Ед.л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2016-04-01T00:00:00Z",
                "value": 46.89,
                "warning_bottom_edge": 17,
                "warning_top_edge": 33
            },
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 24.69,
                "warning_bottom_edge": 17,
                "warning_top_edge": 33
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 20.02,
                "warning_bottom_edge": 17,
                "warning_top_edge": 33
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 13.66,
                "warning_bottom_edge": 17,
                "warning_top_edge": 33
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 22.67,
                "warning_bottom_edge": 17,
                "warning_top_edge": 33
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 21.23,
                "warning_bottom_edge": 17,
                "warning_top_edge": 33
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 31.02,
                "warning_bottom_edge": 17,
                "warning_top_edge": 33
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 30.49,
                "warning_bottom_edge": 17,
                "warning_top_edge": 33
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 28.05,
                "warning_bottom_edge": 17,
                "warning_top_edge": 33
            },
            {
                "panel_id": 10015,
                "made_at": "2018-07-04T00:00:00Z",
                "value": 18.94,
                "warning_bottom_edge": 17,
                "warning_top_edge": 33
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 10.1,
                "warning_bottom_edge": 17,
                "warning_top_edge": 33
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 41.12,
                "warning_bottom_edge": 17,
                "warning_top_edge": 33
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 29.55,
                "warning_bottom_edge": 17,
                "warning_top_edge": 33
            }
        ]
    },
    "АСТ": {
        "units": "Ед/л",
        "values": [
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 16.613999999999997,
                "warning_bottom_edge": 0,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10009,
                "made_at": "2018-03-16T00:00:00Z",
                "value": 27.494,
                "warning_bottom_edge": 0,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 23.064000000000004,
                "warning_bottom_edge": 0,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 16.5,
                "warning_bottom_edge": 0,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 41.400000000000006,
                "warning_bottom_edge": 0,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 11.55,
                "warning_bottom_edge": 0,
                "warning_top_edge": 50
            }
        ]
    },
    "Фосфатаза щелочная": {
        "units": "Ед/л",
        "values": [
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 51.43,
                "warning_bottom_edge": 30,
                "warning_top_edge": 120
            },
            {
                "panel_id": 10009,
                "made_at": "2018-03-16T00:00:00Z",
                "value": 114.04,
                "warning_bottom_edge": 30,
                "warning_top_edge": 120
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 54.33,
                "warning_bottom_edge": 30,
                "warning_top_edge": 120
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 48.83,
                "warning_bottom_edge": 30,
                "warning_top_edge": 120
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 105.49,
                "warning_bottom_edge": 30,
                "warning_top_edge": 120
            }
        ]
    },
    "Билирубин": {
        "units": "мкмоль/л",
        "values": [
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 15.24,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 24.73,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 20.98,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 9.7,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            },
            {
                "panel_id": 10009,
                "made_at": "2018-03-16T00:00:00Z",
                "value": 19.71,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            },
            {
                "panel_id": 10010,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 10.35,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-30T00:00:00Z",
                "value": 19.49,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            },
            {
                "panel_id": 10012,
                "made_at": "2018-04-01T00:00:00Z",
                "value": 6.8,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 6.22,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 4.26,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            },
            {
                "panel_id": 10015,
                "made_at": "2018-07-04T00:00:00Z",
                "value": 9.24,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 11.61,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 26.49,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 11.69,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 16.93,
                "warning_bottom_edge": 5,
                "warning_top_edge": 21
            }
        ]
    },
    "Билирубин прямой": {
        "units": "мкмоль/л",
        "values": [
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 2.6,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.6
            },
            {
                "panel_id": 10009,
                "made_at": "2018-03-16T00:00:00Z",
                "value": 3.84,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.6
            },
            {
                "panel_id": 10010,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 2.7169999999999996,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.6
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-30T00:00:00Z",
                "value": 4.123,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.6
            },
            {
                "panel_id": 10012,
                "made_at": "2018-04-01T00:00:00Z",
                "value": 3.2750000000000004,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.6
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 2.0749999999999997,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.6
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 4.389,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.6
            },
            {
                "panel_id": 10015,
                "made_at": "2018-07-04T00:00:00Z",
                "value": 3.683,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.6
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 1.8090000000000002,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.6
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 9.447,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.6
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 5.61,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.6
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 5.8500000000000005,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.6
            }
        ]
    },
    "Альбумин": {
        "units": "г/л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2016-04-01T00:00:00Z",
                "value": 43.76,
                "warning_bottom_edge": 43,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 48.77,
                "warning_bottom_edge": 43,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 46.91,
                "warning_bottom_edge": 43,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10007,
                "made_at": "2017-11-22T00:00:00Z",
                "value": 60.88,
                "warning_bottom_edge": 43,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 48.22,
                "warning_bottom_edge": 43,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 57.16,
                "warning_bottom_edge": 43,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10015,
                "made_at": "2018-07-04T00:00:00Z",
                "value": 60.89,
                "warning_bottom_edge": 43,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 49.57,
                "warning_bottom_edge": 43,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 45.14,
                "warning_bottom_edge": 43,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 47.42,
                "warning_bottom_edge": 43,
                "warning_top_edge": 50
            }
        ]
    },
    "Креатинин": {
        "units": "мкмоль/л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2016-04-01T00:00:00Z",
                "value": 66.56,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 141.38,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 72.63,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 64.61,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 97.39,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 85.73,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 87.5,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10009,
                "made_at": "2018-03-16T00:00:00Z",
                "value": 54.44,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10010,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 79.29,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-30T00:00:00Z",
                "value": 52.04,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10012,
                "made_at": "2018-04-01T00:00:00Z",
                "value": 89.61,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 71.49,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 93.14,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10015,
                "made_at": "2018-07-04T00:00:00Z",
                "value": 63.65,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 72.3,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 41.05,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 79.6,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 98.5,
                "warning_bottom_edge": 64,
                "warning_top_edge": 104
            }
        ]
    },
    "СКФ": {
        "units": "мл/мин/1,73 м2",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2016-04-01T00:00:00Z",
                "value": 159.45,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 65.61,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 84.86,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 105.58,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 61.83,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 88.53,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 46.72,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10009,
                "made_at": "2018-03-16T00:00:00Z",
                "value": 118.94,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10010,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 75.24,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-30T00:00:00Z",
                "value": 74.32,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10012,
                "made_at": "2018-04-01T00:00:00Z",
                "value": 86.58,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 103.48,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 60.7,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10015,
                "made_at": "2018-07-04T00:00:00Z",
                "value": 81.39,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 69.89,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 137.99,
                "warning_bottom_edge": 60,
                "warning_top_edge": 108
            }
        ]
    },
    "Цистатин С": {
        "units": "мг/л",
        "values": [
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 0.5,
                "warning_bottom_edge": 0.61,
                "warning_top_edge": 0.95
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 0.61,
                "warning_bottom_edge": 0.61,
                "warning_top_edge": 0.95
            },
            {
                "panel_id": 10009,
                "made_at": "2018-03-16T00:00:00Z",
                "value": 0.86,
                "warning_bottom_edge": 0.61,
                "warning_top_edge": 0.95
            },
            {
                "panel_id": 10010,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 0.67,
                "warning_bottom_edge": 0.61,
                "warning_top_edge": 0.95
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-30T00:00:00Z",
                "value": 0.4,
                "warning_bottom_edge": 0.61,
                "warning_top_edge": 0.95
            }
        ]
    },
    "СКФ по цистатину С": {
        "units": "мл/мин/1,73 м2",
        "values": [
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 106.23,
                "warning_bottom_edge": 75,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 89.02,
                "warning_bottom_edge": 75,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10009,
                "made_at": "2018-03-16T00:00:00Z",
                "value": 70.9,
                "warning_bottom_edge": 75,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10010,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 104.09,
                "warning_bottom_edge": 75,
                "warning_top_edge": 108
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-30T00:00:00Z",
                "value": 85.51,
                "warning_bottom_edge": 75,
                "warning_top_edge": 108
            }
        ]
    },
    "Креатинфосфокиназа": {
        "units": "Ед/л",
        "values": [
            {
                "panel_id": 10007,
                "made_at": "2017-11-22T00:00:00Z",
                "value": 92.26400000000001,
                "warning_bottom_edge": 0,
                "warning_top_edge": 190
            },
            {
                "panel_id": 10009,
                "made_at": "2018-03-16T00:00:00Z",
                "value": 93.555,
                "warning_bottom_edge": 0,
                "warning_top_edge": 190
            },
            {
                "panel_id": 10010,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 103.17999999999999,
                "warning_bottom_edge": 0,
                "warning_top_edge": 190
            },
            {
                "panel_id": 10012,
                "made_at": "2018-04-01T00:00:00Z",
                "value": 240.11999999999998,
                "warning_bottom_edge": 0,
                "warning_top_edge": 190
            },
            {
                "panel_id": 10015,
                "made_at": "2018-07-04T00:00:00Z",
                "value": 52.542,
                "warning_bottom_edge": 0,
                "warning_top_edge": 190
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 147.7,
                "warning_bottom_edge": 0,
                "warning_top_edge": 190
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 86.597,
                "warning_bottom_edge": 0,
                "warning_top_edge": 190
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 178.5,
                "warning_bottom_edge": 0,
                "warning_top_edge": 190
            }
        ]
    },
    "Мочевая кислота": {
        "units": "мкмоль/л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2016-04-01T00:00:00Z",
                "value": 274.52,
                "warning_bottom_edge": 210,
                "warning_top_edge": 363
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 244.75,
                "warning_bottom_edge": 210,
                "warning_top_edge": 363
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 432.66,
                "warning_bottom_edge": 210,
                "warning_top_edge": 363
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 304.08,
                "warning_bottom_edge": 210,
                "warning_top_edge": 363
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 155.26,
                "warning_bottom_edge": 210,
                "warning_top_edge": 363
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 241.7,
                "warning_bottom_edge": 210,
                "warning_top_edge": 363
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 244.63,
                "warning_bottom_edge": 210,
                "warning_top_edge": 363
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 297.27,
                "warning_bottom_edge": 210,
                "warning_top_edge": 363
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 259.07,
                "warning_bottom_edge": 210,
                "warning_top_edge": 363
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 279.25,
                "warning_bottom_edge": 210,
                "warning_top_edge": 363
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 317.41,
                "warning_bottom_edge": 210,
                "warning_top_edge": 363
            }
        ]
    },
    "Мочевина": {
        "units": "ммоль/л",
        "values": [
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 6.08,
                "warning_bottom_edge": 2.8,
                "warning_top_edge": 7.2
            },
            {
                "panel_id": 10009,
                "made_at": "2018-03-16T00:00:00Z",
                "value": 6.31,
                "warning_bottom_edge": 2.8,
                "warning_top_edge": 7.2
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 10.01,
                "warning_bottom_edge": 2.8,
                "warning_top_edge": 7.2
            }
        ]
    },
    "Лактат": {
        "units": "ммоль/л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2016-04-01T00:00:00Z",
                "value": 0.78,
                "warning_bottom_edge": 0.5,
                "warning_top_edge": 2.2
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 1.83,
                "warning_bottom_edge": 0.5,
                "warning_top_edge": 2.2
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 0.94,
                "warning_bottom_edge": 0.5,
                "warning_top_edge": 2.2
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 2.88,
                "warning_bottom_edge": 0.5,
                "warning_top_edge": 2.2
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 1.01,
                "warning_bottom_edge": 0.5,
                "warning_top_edge": 2.2
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 0.98,
                "warning_bottom_edge": 0.5,
                "warning_top_edge": 2.2
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 1.1,
                "warning_bottom_edge": 0.5,
                "warning_top_edge": 2.2
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 1.07,
                "warning_bottom_edge": 0.5,
                "warning_top_edge": 2.2
            }
        ]
    },
    "Ваш вес": {
        "units": "кг",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2016-04-01T00:00:00Z",
                "value": 92.95,
                "warning_bottom_edge": 0,
                "warning_top_edge": null
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 46.62,
                "warning_bottom_edge": 0,
                "warning_top_edge": null
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 61.0,
                "warning_bottom_edge": 0,
                "warning_top_edge": null
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 75.64,
                "warning_bottom_edge": 0,
                "warning_top_edge": null
            }
        ]
    },
    "Ваш рост": {
        "units": "см",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2016-04-01T00:00:00Z",
                "value": 117.48,
                "warning_bottom_edge": 0,
                "warning_top_edge": null
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 167.2,
                "warning_bottom_edge": 0,
                "warning_top_edge": null
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 237.60000000000002,
                "warning_bottom_edge": 0,
                "warning_top_edge": null
            }
        ]
    },
    "Окружность талии": {
        "units": "см",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2016-04-01T00:00:00Z",
                "value": 85.60000000000001,
                "warning_bottom_edge": 0,
                "warning_top_edge": 88
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 68.06,
                "warning_bottom_edge": 0,
                "warning_top_edge": 88
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 106.5,
                "warning_bottom_edge": 0,
                "warning_top_edge": 88
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 56.25,
                "warning_bottom_edge": 0,
                "warning_top_edge": 88
            }
        ]
    },
    "Окружность шеи": {
        "units": "см",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2016-04-01T00:00:00Z",
                "value": 48.1,
                "warning_bottom_edge": 0,
                "warning_top_edge": null
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 21.459999999999997,
                "warning_bottom_edge": 0,
                "warning_top_edge": null
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 33.6,
                "warning_bottom_edge": 0,
                "warning_top_edge": null
            }
        ]
    },
    "Окружность бедер": {
        "units": "см",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2016-04-01T00:00:00Z",
                "value": 120.65,
                "warning_bottom_edge": 0,
                "warning_top_edge": null
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 51.3,
                "warning_bottom_edge": 0,
                "warning_top_edge": null
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 47.17,
                "warning_bottom_edge": 0,
                "warning_top_edge": null
            }
        ]
    },
    "Индекс массы тела": {
        "units": "м2",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2016-04-01T00:00:00Z",
                "value": 30.82,
                "warning_bottom_edge": 22.5,
                "warning_top_edge": 25
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 28.69,
                "warning_bottom_edge": 22.5,
                "warning_top_edge": 25
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 25.1,
                "warning_bottom_edge": 22.5,
                "warning_top_edge": 25
            }
        ]
    },
    "Альфа-фетопротеин": {
        "units": "МЕ/мл",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2016-04-01T00:00:00Z",
                "value": 3.286,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.2
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 5.6240000000000006,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.2
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 4.501600000000001,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.2
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 11.1804,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.2
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 10.453800000000001,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.2
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 8.9278,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.2
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 8.1529,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.2
            },
            {
                "panel_id": 10015,
                "made_at": "2018-07-04T00:00:00Z",
                "value": 9.1419,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.2
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 7.1861999999999995,
                "warning_bottom_edge": 0,
                "warning_top_edge": 8.2
            }
        ]
    },

    "С-реактивный белок": {
        "units": "мг/л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2016-04-01T00:00:00Z",
                "value": 0.1065,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.0
            },
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 0.177,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.0
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 0.15120000000000003,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.0
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 0.9401,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.0
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 0.17800000000000002,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.0
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 0.7821,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.0
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 0.182,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.0
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 1.0151999999999999,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.0
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 0.123,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.0
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 0.10800000000000001,
                "warning_bottom_edge": 0,
                "warning_top_edge": 1.0
            }
        ]
    },
    "Гемоглобин": {
        "units": "г/л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2016-04-01T00:00:00Z",
                "value": 162.77,
                "warning_bottom_edge": 132,
                "warning_top_edge": 173
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 169.15,
                "warning_bottom_edge": 132,
                "warning_top_edge": 173
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 69.36,
                "warning_bottom_edge": 132,
                "warning_top_edge": 173
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 132.21,
                "warning_bottom_edge": 132,
                "warning_top_edge": 173
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 166.19,
                "warning_bottom_edge": 132,
                "warning_top_edge": 173
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 143.78,
                "warning_bottom_edge": 132,
                "warning_top_edge": 173
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 164.3,
                "warning_bottom_edge": 132,
                "warning_top_edge": 173
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 146.33,
                "warning_bottom_edge": 132,
                "warning_top_edge": 173
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 160.39,
                "warning_bottom_edge": 132,
                "warning_top_edge": 173
            },
            {
                "panel_id": 10015,
                "made_at": "2018-07-04T00:00:00Z",
                "value": 146.31,
                "warning_bottom_edge": 132,
                "warning_top_edge": 173
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 105.19,
                "warning_bottom_edge": 132,
                "warning_top_edge": 173
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 136.53,
                "warning_bottom_edge": 132,
                "warning_top_edge": 173
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 156.81,
                "warning_bottom_edge": 132,
                "warning_top_edge": 173
            }
        ]
    },
    "Гематокрит": {
        "units": "%",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 42.13,
                "warning_bottom_edge": 39,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 48.62,
                "warning_bottom_edge": 39,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 49.59,
                "warning_bottom_edge": 39,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 64.51,
                "warning_bottom_edge": 39,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 46.07,
                "warning_bottom_edge": 39,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 42.75,
                "warning_bottom_edge": 39,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 47.45,
                "warning_bottom_edge": 39,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 40.17,
                "warning_bottom_edge": 39,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 39.01,
                "warning_bottom_edge": 39,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 46.06,
                "warning_bottom_edge": 39,
                "warning_top_edge": 50
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 42.11,
                "warning_bottom_edge": 39,
                "warning_top_edge": 50
            }
        ]
    },
    "Витамин В12": {
        "units": "пг/мл",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2016-04-01T00:00:00Z",
                "value": 429.11,
                "warning_bottom_edge": 200,
                "warning_top_edge": 814
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 318.23,
                "warning_bottom_edge": 200,
                "warning_top_edge": 814
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 627.3,
                "warning_bottom_edge": 200,
                "warning_top_edge": 814
            },
            {
                "panel_id": 10007,
                "made_at": "2017-11-22T00:00:00Z",
                "value": 169.96,
                "warning_bottom_edge": 200,
                "warning_top_edge": 814
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 345.07,
                "warning_bottom_edge": 200,
                "warning_top_edge": 814
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 987.29,
                "warning_bottom_edge": 200,
                "warning_top_edge": 814
            }
        ]
    },
    "Гомоцистеин": {
        "units": "мкмоль/л",
        "values": [
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 6.97,
                "warning_bottom_edge": 5.46,
                "warning_top_edge": 16.2
            },
            {
                "panel_id": 10009,
                "made_at": "2018-03-16T00:00:00Z",
                "value": 11.23,
                "warning_bottom_edge": 5.46,
                "warning_top_edge": 16.2
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 12.99,
                "warning_bottom_edge": 5.46,
                "warning_top_edge": 16.2
            }
        ]
    },
    "Витамин D": {
        "units": "нг/мл",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 80.37,
                "warning_bottom_edge": 20,
                "warning_top_edge": 56
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 35.87,
                "warning_bottom_edge": 20,
                "warning_top_edge": 56
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 30.92,
                "warning_bottom_edge": 20,
                "warning_top_edge": 56
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 41.34,
                "warning_bottom_edge": 20,
                "warning_top_edge": 56
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 42.26,
                "warning_bottom_edge": 20,
                "warning_top_edge": 56
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 43.15,
                "warning_bottom_edge": 20,
                "warning_top_edge": 56
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 24.26,
                "warning_bottom_edge": 20,
                "warning_top_edge": 56
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 39.18,
                "warning_bottom_edge": 20,
                "warning_top_edge": 56
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 27.06,
                "warning_bottom_edge": 20,
                "warning_top_edge": 56
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 31.01,
                "warning_bottom_edge": 20,
                "warning_top_edge": 56
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 27.31,
                "warning_bottom_edge": 20,
                "warning_top_edge": 56
            }
        ]
    },
    "Калий": {
        "units": "ммоль/л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2016-04-01T00:00:00Z",
                "value": 4.35,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 5.5
            },
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 4.25,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 5.5
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 3.78,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 5.5
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 7.22,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 5.5
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 7.21,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 5.5
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 2.24,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 5.5
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 3.93,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 5.5
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 5.05,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 5.5
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 3.75,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 5.5
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 5.17,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 5.5
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 5.06,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 5.5
            }
        ]
    },
    "Натрий": {
        "units": "ммоль/л",
        "values": [
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 136.83,
                "warning_bottom_edge": 136,
                "warning_top_edge": 145
            }
        ]
    },
    "Цинк": {
        "units": "мкмоль/л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2016-04-01T00:00:00Z",
                "value": 14.93,
                "warning_bottom_edge": 10.7,
                "warning_top_edge": 18.4
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 12.72,
                "warning_bottom_edge": 10.7,
                "warning_top_edge": 18.4
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 13.61,
                "warning_bottom_edge": 10.7,
                "warning_top_edge": 18.4
            },
            {
                "panel_id": 10007,
                "made_at": "2017-11-22T00:00:00Z",
                "value": 13.14,
                "warning_bottom_edge": 10.7,
                "warning_top_edge": 18.4
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 14.0,
                "warning_bottom_edge": 10.7,
                "warning_top_edge": 18.4
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 15.7,
                "warning_bottom_edge": 10.7,
                "warning_top_edge": 18.4
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 16.73,
                "warning_bottom_edge": 10.7,
                "warning_top_edge": 18.4
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 11.71,
                "warning_bottom_edge": 10.7,
                "warning_top_edge": 18.4
            }
        ]
    },
    "Фолиевая кислота": {
        "units": "нг/мл",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 7.71,
                "warning_bottom_edge": 3.0,
                "warning_top_edge": 17.0
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 9.57,
                "warning_bottom_edge": 3.0,
                "warning_top_edge": 17.0
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 5.3,
                "warning_bottom_edge": 3.0,
                "warning_top_edge": 17.0
            },
            {
                "panel_id": 10007,
                "made_at": "2017-11-22T00:00:00Z",
                "value": 3.69,
                "warning_bottom_edge": 3.0,
                "warning_top_edge": 17.0
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 12.47,
                "warning_bottom_edge": 3.0,
                "warning_top_edge": 17.0
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 2.42,
                "warning_bottom_edge": 3.0,
                "warning_top_edge": 17.0
            }
        ]
    },
    "Железо": {
        "units": "мкмоль/л",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2016-04-01T00:00:00Z",
                "value": 29.74,
                "warning_bottom_edge": 12.5,
                "warning_top_edge": 32.2
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 17.2,
                "warning_bottom_edge": 12.5,
                "warning_top_edge": 32.2
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 18.73,
                "warning_bottom_edge": 12.5,
                "warning_top_edge": 32.2
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 14.98,
                "warning_bottom_edge": 12.5,
                "warning_top_edge": 32.2
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 29.82,
                "warning_bottom_edge": 12.5,
                "warning_top_edge": 32.2
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 25.35,
                "warning_bottom_edge": 12.5,
                "warning_top_edge": 32.2
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 15.27,
                "warning_bottom_edge": 12.5,
                "warning_top_edge": 32.2
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 22.12,
                "warning_bottom_edge": 12.5,
                "warning_top_edge": 32.2
            },
            {
                "panel_id": 10015,
                "made_at": "2018-07-04T00:00:00Z",
                "value": 16.56,
                "warning_bottom_edge": 12.5,
                "warning_top_edge": 32.2
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 10.65,
                "warning_bottom_edge": 12.5,
                "warning_top_edge": 32.2
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 8.91,
                "warning_bottom_edge": 12.5,
                "warning_top_edge": 32.2
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 14.76,
                "warning_bottom_edge": 12.5,
                "warning_top_edge": 32.2
            }
        ]
    },
    "Ферритин": {
        "units": "нг/мл",
        "values": [
            {
                "panel_id": 10001,
                "made_at": "2016-04-01T00:00:00Z",
                "value": 167.83,
                "warning_bottom_edge": 20,
                "warning_top_edge": 250
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 226.08,
                "warning_bottom_edge": 20,
                "warning_top_edge": 250
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 14.02,
                "warning_bottom_edge": 20,
                "warning_top_edge": 250
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 187.8,
                "warning_bottom_edge": 20,
                "warning_top_edge": 250
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 20.87,
                "warning_bottom_edge": 20,
                "warning_top_edge": 250
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 17.55,
                "warning_bottom_edge": 20,
                "warning_top_edge": 250
            },
            {
                "panel_id": 10011,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 318.66,
                "warning_bottom_edge": 20,
                "warning_top_edge": 250
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 185.3,
                "warning_bottom_edge": 20,
                "warning_top_edge": 250
            },
            {
                "panel_id": 10015,
                "made_at": "2018-07-04T00:00:00Z",
                "value": 226.75,
                "warning_bottom_edge": 20,
                "warning_top_edge": 250
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 162.21,
                "warning_bottom_edge": 20,
                "warning_top_edge": 250
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 65.75,
                "warning_bottom_edge": 20,
                "warning_top_edge": 250
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 22.63,
                "warning_bottom_edge": 20,
                "warning_top_edge": 250
            }
        ]
    },
    "Трансферрин": {
        "units": "г/л",
        "values": [
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 2.92,
                "warning_bottom_edge": 2.0,
                "warning_top_edge": 3.6
            },
            {
                "panel_id": 10010,
                "made_at": "2018-03-31T00:00:00Z",
                "value": 2.79,
                "warning_bottom_edge": 2.0,
                "warning_top_edge": 3.6
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 2.47,
                "warning_bottom_edge": 2.0,
                "warning_top_edge": 3.6
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 2.38,
                "warning_bottom_edge": 2.0,
                "warning_top_edge": 3.6
            }
        ]
    },
    "Тромбоциты (PLT)": {
        "units": "10^9/л",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 489.44,
                "warning_bottom_edge": 150,
                "warning_top_edge": 400
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 161.12,
                "warning_bottom_edge": 150,
                "warning_top_edge": 400
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 569.4,
                "warning_bottom_edge": 150,
                "warning_top_edge": 400
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 176.7,
                "warning_bottom_edge": 150,
                "warning_top_edge": 400
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 358.4,
                "warning_bottom_edge": 150,
                "warning_top_edge": 400
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 370.18,
                "warning_bottom_edge": 150,
                "warning_top_edge": 400
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 232.24,
                "warning_bottom_edge": 150,
                "warning_top_edge": 400
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 239.19,
                "warning_bottom_edge": 150,
                "warning_top_edge": 400
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 327.93,
                "warning_bottom_edge": 150,
                "warning_top_edge": 400
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 224.45,
                "warning_bottom_edge": 150,
                "warning_top_edge": 400
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 255.82,
                "warning_bottom_edge": 150,
                "warning_top_edge": 400
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 377.28,
                "warning_bottom_edge": 150,
                "warning_top_edge": 400
            }
        ]
    },
    "Тромбоциты по Фонио": {
        "units": "10^9/л",
        "values": [
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 168.75,
                "warning_bottom_edge": 150,
                "warning_top_edge": 400
            }
        ]
    },
    "Эритроциты (RBC)": {
        "units": "10^12/л",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 4.74,
                "warning_bottom_edge": 4.24,
                "warning_top_edge": 5.65
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 5.61,
                "warning_bottom_edge": 4.24,
                "warning_top_edge": 5.65
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 5.03,
                "warning_bottom_edge": 4.24,
                "warning_top_edge": 5.65
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 4.41,
                "warning_bottom_edge": 4.24,
                "warning_top_edge": 5.65
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 4.65,
                "warning_bottom_edge": 4.24,
                "warning_top_edge": 5.65
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 4.79,
                "warning_bottom_edge": 4.24,
                "warning_top_edge": 5.65
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 5.38,
                "warning_bottom_edge": 4.24,
                "warning_top_edge": 5.65
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 7.37,
                "warning_bottom_edge": 4.24,
                "warning_top_edge": 5.65
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 2.63,
                "warning_bottom_edge": 4.24,
                "warning_top_edge": 5.65
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 4.72,
                "warning_bottom_edge": 4.24,
                "warning_top_edge": 5.65
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 5.33,
                "warning_bottom_edge": 4.24,
                "warning_top_edge": 5.65
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 6.23,
                "warning_bottom_edge": 4.24,
                "warning_top_edge": 5.65
            }
        ]
    },
    "Средний объём эритроцита (MCV)": {
        "units": "фл",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 143.11,
                "warning_bottom_edge": 86.5,
                "warning_top_edge": 101.79
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 88.74,
                "warning_bottom_edge": 86.5,
                "warning_top_edge": 101.79
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 86.74,
                "warning_bottom_edge": 86.5,
                "warning_top_edge": 101.79
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 93.17,
                "warning_bottom_edge": 86.5,
                "warning_top_edge": 101.79
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 94.3,
                "warning_bottom_edge": 86.5,
                "warning_top_edge": 101.79
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 135.35,
                "warning_bottom_edge": 86.5,
                "warning_top_edge": 101.79
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 95.05,
                "warning_bottom_edge": 86.5,
                "warning_top_edge": 101.79
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 98.69,
                "warning_bottom_edge": 86.5,
                "warning_top_edge": 101.79
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 88.72,
                "warning_bottom_edge": 86.5,
                "warning_top_edge": 101.79
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 98.67,
                "warning_bottom_edge": 86.5,
                "warning_top_edge": 101.79
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 87.27,
                "warning_bottom_edge": 86.5,
                "warning_top_edge": 101.79
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 93.41,
                "warning_bottom_edge": 86.5,
                "warning_top_edge": 101.79
            }
        ]
    },
    "Среднее содержание Hb в эритроците (MCH)": {
        "units": "пг",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 28.09,
                "warning_bottom_edge": 27.23,
                "warning_top_edge": 33.6
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 30.37,
                "warning_bottom_edge": 27.23,
                "warning_top_edge": 33.6
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 28.96,
                "warning_bottom_edge": 27.23,
                "warning_top_edge": 33.6
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 30.58,
                "warning_bottom_edge": 27.23,
                "warning_top_edge": 33.6
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 30.42,
                "warning_bottom_edge": 27.23,
                "warning_top_edge": 33.6
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 31.85,
                "warning_bottom_edge": 27.23,
                "warning_top_edge": 33.6
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 32.99,
                "warning_bottom_edge": 27.23,
                "warning_top_edge": 33.6
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 33.34,
                "warning_bottom_edge": 27.23,
                "warning_top_edge": 33.6
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 30.66,
                "warning_bottom_edge": 27.23,
                "warning_top_edge": 33.6
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 31.71,
                "warning_bottom_edge": 27.23,
                "warning_top_edge": 33.6
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 17.88,
                "warning_bottom_edge": 27.23,
                "warning_top_edge": 33.6
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 28.93,
                "warning_bottom_edge": 27.23,
                "warning_top_edge": 33.6
            }
        ]
    },
    "Средняя концентрация Hb в эритроците (MCHC)": {
        "units": "г/л",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 316.83,
                "warning_bottom_edge": 314.5,
                "warning_top_edge": 360
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 161.37,
                "warning_bottom_edge": 314.5,
                "warning_top_edge": 360
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 344.06,
                "warning_bottom_edge": 314.5,
                "warning_top_edge": 360
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 425.46,
                "warning_bottom_edge": 314.5,
                "warning_top_edge": 360
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 354.73,
                "warning_bottom_edge": 314.5,
                "warning_top_edge": 360
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 346.18,
                "warning_bottom_edge": 314.5,
                "warning_top_edge": 360
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 331.01,
                "warning_bottom_edge": 314.5,
                "warning_top_edge": 360
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 343.58,
                "warning_bottom_edge": 314.5,
                "warning_top_edge": 360
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 354.6,
                "warning_bottom_edge": 314.5,
                "warning_top_edge": 360
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 201.31,
                "warning_bottom_edge": 314.5,
                "warning_top_edge": 360
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 348.41,
                "warning_bottom_edge": 314.5,
                "warning_top_edge": 360
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 350.96000000000004,
                "warning_bottom_edge": 314.5,
                "warning_top_edge": 360
            }
        ]
    },
    "Гетерогенность эритроцитов по объёму (RDW)": {
        "units": "%",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 13.31,
                "warning_bottom_edge": 11.4,
                "warning_top_edge": 15.29
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 13.18,
                "warning_bottom_edge": 11.4,
                "warning_top_edge": 15.29
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 7.28,
                "warning_bottom_edge": 11.4,
                "warning_top_edge": 15.29
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 12.69,
                "warning_bottom_edge": 11.4,
                "warning_top_edge": 15.29
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 14.63,
                "warning_bottom_edge": 11.4,
                "warning_top_edge": 15.29
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 5.71,
                "warning_bottom_edge": 11.4,
                "warning_top_edge": 15.29
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 8.79,
                "warning_bottom_edge": 11.4,
                "warning_top_edge": 15.29
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 14.78,
                "warning_bottom_edge": 11.4,
                "warning_top_edge": 15.29
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 11.4,
                "warning_bottom_edge": 11.4,
                "warning_top_edge": 15.29
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 13.08,
                "warning_bottom_edge": 11.4,
                "warning_top_edge": 15.29
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 13.06,
                "warning_bottom_edge": 11.4,
                "warning_top_edge": 15.29
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 12.58,
                "warning_bottom_edge": 11.4,
                "warning_top_edge": 15.29
            }
        ]
    },
    "Гетерогенность эритроцитов по объёму (RDW-SD)": {
        "units": "фл",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 47.89,
                "warning_bottom_edge": 38.3,
                "warning_top_edge": 51.62
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 38.77,
                "warning_bottom_edge": 38.3,
                "warning_top_edge": 51.62
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 47.53,
                "warning_bottom_edge": 38.3,
                "warning_top_edge": 51.62
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 49.06,
                "warning_bottom_edge": 38.3,
                "warning_top_edge": 51.62
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 38.85,
                "warning_bottom_edge": 38.3,
                "warning_top_edge": 51.62
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 47.82,
                "warning_bottom_edge": 38.3,
                "warning_top_edge": 51.62
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 27.79,
                "warning_bottom_edge": 38.3,
                "warning_top_edge": 51.62
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 43.62,
                "warning_bottom_edge": 38.3,
                "warning_top_edge": 51.62
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 44.67,
                "warning_bottom_edge": 38.3,
                "warning_top_edge": 51.62
            }
        ]
    },
    "Макроциты": {
        "units": "%",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 3.84,
                "warning_bottom_edge": 3.63,
                "warning_top_edge": 7.83
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 4.09,
                "warning_bottom_edge": 3.63,
                "warning_top_edge": 7.83
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 4.49,
                "warning_bottom_edge": 3.63,
                "warning_top_edge": 7.83
            },
            {
                "panel_id": 10009,
                "made_at": "2018-03-16T00:00:00Z",
                "value": 4.52,
                "warning_bottom_edge": 3.63,
                "warning_top_edge": 7.83
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 5.05,
                "warning_bottom_edge": 3.63,
                "warning_top_edge": 7.83
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 4.07,
                "warning_bottom_edge": 3.63,
                "warning_top_edge": 7.83
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 4.01,
                "warning_bottom_edge": 3.63,
                "warning_top_edge": 7.83
            }
        ]
    },
    "Микроциты": {
        "units": "%",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 9.05,
                "warning_bottom_edge": 0.1,
                "warning_top_edge": 6.81
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 0.08,
                "warning_bottom_edge": 0.1,
                "warning_top_edge": 6.81
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 7.65,
                "warning_bottom_edge": 0.1,
                "warning_top_edge": 6.81
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 6.69,
                "warning_bottom_edge": 0.1,
                "warning_top_edge": 6.81
            },
            {
                "panel_id": 10009,
                "made_at": "2018-03-16T00:00:00Z",
                "value": 3.5,
                "warning_bottom_edge": 0.1,
                "warning_top_edge": 6.81
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 4.36,
                "warning_bottom_edge": 0.1,
                "warning_top_edge": 6.81
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 3.59,
                "warning_bottom_edge": 0.1,
                "warning_top_edge": 6.81
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 6.68,
                "warning_bottom_edge": 0.1,
                "warning_top_edge": 6.81
            }
        ]
    },
    "Тромбокрит (PCT)": {
        "units": "%",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 0.23,
                "warning_bottom_edge": 0.16,
                "warning_top_edge": 0.39
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 0.23,
                "warning_bottom_edge": 0.16,
                "warning_top_edge": 0.39
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 0.33,
                "warning_bottom_edge": 0.16,
                "warning_top_edge": 0.39
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 0.27,
                "warning_bottom_edge": 0.16,
                "warning_top_edge": 0.39
            },
            {
                "panel_id": 10009,
                "made_at": "2018-03-16T00:00:00Z",
                "value": 0.21,
                "warning_bottom_edge": 0.16,
                "warning_top_edge": 0.39
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 0.12,
                "warning_bottom_edge": 0.16,
                "warning_top_edge": 0.39
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 0.19,
                "warning_bottom_edge": 0.16,
                "warning_top_edge": 0.39
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 0.18,
                "warning_bottom_edge": 0.16,
                "warning_top_edge": 0.39
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 0.36,
                "warning_bottom_edge": 0.16,
                "warning_top_edge": 0.39
            }
        ]
    },
    "Средний объем тромбоцитов (MPV)": {
        "units": "фл",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 7.57,
                "warning_bottom_edge": 9.1,
                "warning_top_edge": 12.6
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 11.87,
                "warning_bottom_edge": 9.1,
                "warning_top_edge": 12.6
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 10.2,
                "warning_bottom_edge": 9.1,
                "warning_top_edge": 12.6
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 10.26,
                "warning_bottom_edge": 9.1,
                "warning_top_edge": 12.6
            },
            {
                "panel_id": 10009,
                "made_at": "2018-03-16T00:00:00Z",
                "value": 17.39,
                "warning_bottom_edge": 9.1,
                "warning_top_edge": 12.6
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 8.51,
                "warning_bottom_edge": 9.1,
                "warning_top_edge": 12.6
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 10.84,
                "warning_bottom_edge": 9.1,
                "warning_top_edge": 12.6
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 11.86,
                "warning_bottom_edge": 9.1,
                "warning_top_edge": 12.6
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 7.44,
                "warning_bottom_edge": 9.1,
                "warning_top_edge": 12.6
            }
        ]
    },
    "Гетерогенность тромбоцитов по объему (PDW)": {
        "units": "фл",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 11.67,
                "warning_bottom_edge": 9.3,
                "warning_top_edge": 16.7
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 14.56,
                "warning_bottom_edge": 9.3,
                "warning_top_edge": 16.7
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 16.11,
                "warning_bottom_edge": 9.3,
                "warning_top_edge": 16.7
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 8.96,
                "warning_bottom_edge": 9.3,
                "warning_top_edge": 16.7
            },
            {
                "panel_id": 10009,
                "made_at": "2018-03-16T00:00:00Z",
                "value": 10.36,
                "warning_bottom_edge": 9.3,
                "warning_top_edge": 16.7
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 16.08,
                "warning_bottom_edge": 9.3,
                "warning_top_edge": 16.7
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 15.27,
                "warning_bottom_edge": 9.3,
                "warning_top_edge": 16.7
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 13.14,
                "warning_bottom_edge": 9.3,
                "warning_top_edge": 16.7
            }
        ]
    },
    "Коэффициент числа крупных тромбоцитов (P-LCR)": {
        "units": "%",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 29.32,
                "warning_bottom_edge": 17.21,
                "warning_top_edge": 46.29
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 34.27,
                "warning_bottom_edge": 17.21,
                "warning_top_edge": 46.29
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 35.71,
                "warning_bottom_edge": 17.21,
                "warning_top_edge": 46.29
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 43.79,
                "warning_bottom_edge": 17.21,
                "warning_top_edge": 46.29
            },
            {
                "panel_id": 10009,
                "made_at": "2018-03-16T00:00:00Z",
                "value": 43.69,
                "warning_bottom_edge": 17.21,
                "warning_top_edge": 46.29
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 15.28,
                "warning_bottom_edge": 17.21,
                "warning_top_edge": 46.29
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 20.0,
                "warning_bottom_edge": 17.21,
                "warning_top_edge": 46.29
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 17.82,
                "warning_bottom_edge": 17.21,
                "warning_top_edge": 46.29
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 35.2,
                "warning_bottom_edge": 17.21,
                "warning_top_edge": 46.29
            }
        ]
    },
    "Лейкоциты (WBC)": {
        "units": "10^9/л",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 6.81,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 9.23
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 8.99,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 9.23
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 5.49,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 9.23
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 4.46,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 9.23
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 5.83,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 9.23
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 4.85,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 9.23
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 2.53,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 9.23
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 9.04,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 9.23
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 5.41,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 9.23
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 6.26,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 9.23
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 8.81,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 9.23
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 4.2,
                "warning_bottom_edge": 3.5,
                "warning_top_edge": 9.23
            }
        ]
    },
    "Нейтрофилы (NEU)": {
        "units": "10^9/л",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 4.18,
                "warning_bottom_edge": 1.78,
                "warning_top_edge": 6.04
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 3.22,
                "warning_bottom_edge": 1.78,
                "warning_top_edge": 6.04
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 1.56,
                "warning_bottom_edge": 1.78,
                "warning_top_edge": 6.04
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 4.05,
                "warning_bottom_edge": 1.78,
                "warning_top_edge": 6.04
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 4.95,
                "warning_bottom_edge": 1.78,
                "warning_top_edge": 6.04
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 2.48,
                "warning_bottom_edge": 1.78,
                "warning_top_edge": 6.04
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 7.43,
                "warning_bottom_edge": 1.78,
                "warning_top_edge": 6.04
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 5.89,
                "warning_bottom_edge": 1.78,
                "warning_top_edge": 6.04
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 5.94,
                "warning_bottom_edge": 1.78,
                "warning_top_edge": 6.04
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 4.64,
                "warning_bottom_edge": 1.78,
                "warning_top_edge": 6.04
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 2.37,
                "warning_bottom_edge": 1.78,
                "warning_top_edge": 6.04
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 4.33,
                "warning_bottom_edge": 1.78,
                "warning_top_edge": 6.04
            }
        ]
    },
    "Эозинофилы (EOS)": {
        "units": "10^9/л",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 0.46,
                "warning_bottom_edge": 0.04,
                "warning_top_edge": 0.58
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 0.21,
                "warning_bottom_edge": 0.04,
                "warning_top_edge": 0.58
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 0.46,
                "warning_bottom_edge": 0.04,
                "warning_top_edge": 0.58
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 0.1,
                "warning_bottom_edge": 0.04,
                "warning_top_edge": 0.58
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 0.45,
                "warning_bottom_edge": 0.04,
                "warning_top_edge": 0.58
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 0.64,
                "warning_bottom_edge": 0.04,
                "warning_top_edge": 0.58
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 0.08,
                "warning_bottom_edge": 0.04,
                "warning_top_edge": 0.58
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 0.06,
                "warning_bottom_edge": 0.04,
                "warning_top_edge": 0.58
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 0.1,
                "warning_bottom_edge": 0.04,
                "warning_top_edge": 0.58
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 0.05,
                "warning_bottom_edge": 0.04,
                "warning_top_edge": 0.58
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 0.12,
                "warning_bottom_edge": 0.04,
                "warning_top_edge": 0.58
            }
        ]
    },
    "Базофилы (BAS)": {
        "units": "10^9/л",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 0.04,
                "warning_bottom_edge": 0.01,
                "warning_top_edge": 0.09
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 0.06,
                "warning_bottom_edge": 0.01,
                "warning_top_edge": 0.09
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 0.03,
                "warning_bottom_edge": 0.01,
                "warning_top_edge": 0.09
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 0.03,
                "warning_bottom_edge": 0.01,
                "warning_top_edge": 0.09
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 0.07,
                "warning_bottom_edge": 0.01,
                "warning_top_edge": 0.09
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 0.04,
                "warning_bottom_edge": 0.01,
                "warning_top_edge": 0.09
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 0.01,
                "warning_bottom_edge": 0.01,
                "warning_top_edge": 0.09
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 0.05,
                "warning_bottom_edge": 0.01,
                "warning_top_edge": 0.09
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 0.01,
                "warning_bottom_edge": 0.01,
                "warning_top_edge": 0.09
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 0.02,
                "warning_bottom_edge": 0.01,
                "warning_top_edge": 0.09
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 0.13,
                "warning_bottom_edge": 0.01,
                "warning_top_edge": 0.09
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 0.05,
                "warning_bottom_edge": 0.01,
                "warning_top_edge": 0.09
            }
        ]
    },
    "Моноциты (MON)": {
        "units": "10^9/л",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 0.66,
                "warning_bottom_edge": 0.29,
                "warning_top_edge": 0.72
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 0.57,
                "warning_bottom_edge": 0.29,
                "warning_top_edge": 0.72
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 0.46,
                "warning_bottom_edge": 0.29,
                "warning_top_edge": 0.72
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 0.65,
                "warning_bottom_edge": 0.29,
                "warning_top_edge": 0.72
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 0.64,
                "warning_bottom_edge": 0.29,
                "warning_top_edge": 0.72
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 0.22,
                "warning_bottom_edge": 0.29,
                "warning_top_edge": 0.72
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 0.59,
                "warning_bottom_edge": 0.29,
                "warning_top_edge": 0.72
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 0.46,
                "warning_bottom_edge": 0.29,
                "warning_top_edge": 0.72
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 0.22,
                "warning_bottom_edge": 0.29,
                "warning_top_edge": 0.72
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 0.26,
                "warning_bottom_edge": 0.29,
                "warning_top_edge": 0.72
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 0.35,
                "warning_bottom_edge": 0.29,
                "warning_top_edge": 0.72
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 0.51,
                "warning_bottom_edge": 0.29,
                "warning_top_edge": 0.72
            }
        ]
    },
    "Лимфоциты (LYM)": {
        "units": "10^9/л",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 3.0,
                "warning_bottom_edge": 1.24,
                "warning_top_edge": 3.05
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 3.75,
                "warning_bottom_edge": 1.24,
                "warning_top_edge": 3.05
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 1.08,
                "warning_bottom_edge": 1.24,
                "warning_top_edge": 3.05
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 0.67,
                "warning_bottom_edge": 1.24,
                "warning_top_edge": 3.05
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 2.31,
                "warning_bottom_edge": 1.24,
                "warning_top_edge": 3.05
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 1.8,
                "warning_bottom_edge": 1.24,
                "warning_top_edge": 3.05
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 2.02,
                "warning_bottom_edge": 1.24,
                "warning_top_edge": 3.05
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 2.58,
                "warning_bottom_edge": 1.24,
                "warning_top_edge": 3.05
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 2.95,
                "warning_bottom_edge": 1.24,
                "warning_top_edge": 3.05
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 1.99,
                "warning_bottom_edge": 1.24,
                "warning_top_edge": 3.05
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 1.04,
                "warning_bottom_edge": 1.24,
                "warning_top_edge": 3.05
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 1.84,
                "warning_bottom_edge": 1.24,
                "warning_top_edge": 3.05
            }
        ]
    },
    "Незрелые гранулоциты (IG)": {
        "units": "10^9/л",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 0.0111,
                "warning_bottom_edge": 0,
                "warning_top_edge": 0.04
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 0.006500000000000001,
                "warning_bottom_edge": 0,
                "warning_top_edge": 0.04
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 0.033,
                "warning_bottom_edge": 0,
                "warning_top_edge": 0.04
            },
            {
                "panel_id": 10009,
                "made_at": "2018-03-16T00:00:00Z",
                "value": 0.0153,
                "warning_bottom_edge": 0,
                "warning_top_edge": 0.04
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 0.0139,
                "warning_bottom_edge": 0,
                "warning_top_edge": 0.04
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 0.0106,
                "warning_bottom_edge": 0,
                "warning_top_edge": 0.04
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 0.0102,
                "warning_bottom_edge": 0,
                "warning_top_edge": 0.04
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 0.0102,
                "warning_bottom_edge": 0,
                "warning_top_edge": 0.04
            }
        ]
    },
    "Нейтрофилы (NEU %)": {
        "units": "%",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 51.16,
                "warning_bottom_edge": 40.8,
                "warning_top_edge": 70.39
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 47.28,
                "warning_bottom_edge": 40.8,
                "warning_top_edge": 70.39
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 59.6,
                "warning_bottom_edge": 40.8,
                "warning_top_edge": 70.39
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 42.63,
                "warning_bottom_edge": 40.8,
                "warning_top_edge": 70.39
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 64.89,
                "warning_bottom_edge": 40.8,
                "warning_top_edge": 70.39
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 94.05,
                "warning_bottom_edge": 40.8,
                "warning_top_edge": 70.39
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 65.55,
                "warning_bottom_edge": 40.8,
                "warning_top_edge": 70.39
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 60.62,
                "warning_bottom_edge": 40.8,
                "warning_top_edge": 70.39
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 88.8,
                "warning_bottom_edge": 40.8,
                "warning_top_edge": 70.39
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 56.01,
                "warning_bottom_edge": 40.8,
                "warning_top_edge": 70.39
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 51.22,
                "warning_bottom_edge": 40.8,
                "warning_top_edge": 70.39
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 104.88,
                "warning_bottom_edge": 40.8,
                "warning_top_edge": 70.39
            }
        ]
    },
    "Эозинофилы (EOS %)": {
        "units": "%",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 0.6,
                "warning_bottom_edge": 0.73,
                "warning_top_edge": 8.86
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 6.6,
                "warning_bottom_edge": 0.73,
                "warning_top_edge": 8.86
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 5.76,
                "warning_bottom_edge": 0.73,
                "warning_top_edge": 8.86
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 7.14,
                "warning_bottom_edge": 0.73,
                "warning_top_edge": 8.86
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 4.23,
                "warning_bottom_edge": 0.73,
                "warning_top_edge": 8.86
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 3.7,
                "warning_bottom_edge": 0.73,
                "warning_top_edge": 8.86
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 1.41,
                "warning_bottom_edge": 0.73,
                "warning_top_edge": 8.86
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 3.31,
                "warning_bottom_edge": 0.73,
                "warning_top_edge": 8.86
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 1.89,
                "warning_bottom_edge": 0.73,
                "warning_top_edge": 8.86
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 5.67,
                "warning_bottom_edge": 0.73,
                "warning_top_edge": 8.86
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 4.17,
                "warning_bottom_edge": 0.73,
                "warning_top_edge": 8.86
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 6.02,
                "warning_bottom_edge": 0.73,
                "warning_top_edge": 8.86
            }
        ]
    },
    "Базофилы (BAS %)": {
        "units": "%",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 2.18,
                "warning_bottom_edge": 0.2,
                "warning_top_edge": 1.5
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 1.28,
                "warning_bottom_edge": 0.2,
                "warning_top_edge": 1.5
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 0.46,
                "warning_bottom_edge": 0.2,
                "warning_top_edge": 1.5
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 0.13,
                "warning_bottom_edge": 0.2,
                "warning_top_edge": 1.5
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 1.17,
                "warning_bottom_edge": 0.2,
                "warning_top_edge": 1.5
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 0.46,
                "warning_bottom_edge": 0.2,
                "warning_top_edge": 1.5
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 0.63,
                "warning_bottom_edge": 0.2,
                "warning_top_edge": 1.5
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 0.27,
                "warning_bottom_edge": 0.2,
                "warning_top_edge": 1.5
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 0.4,
                "warning_bottom_edge": 0.2,
                "warning_top_edge": 1.5
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 0.81,
                "warning_bottom_edge": 0.2,
                "warning_top_edge": 1.5
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 0.41,
                "warning_bottom_edge": 0.2,
                "warning_top_edge": 1.5
            }
        ]
    },
    "Моноциты (MON %)": {
        "units": "%",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 3.67,
                "warning_bottom_edge": 4.91,
                "warning_top_edge": 10.38
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 7.99,
                "warning_bottom_edge": 4.91,
                "warning_top_edge": 10.38
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 8.89,
                "warning_bottom_edge": 4.91,
                "warning_top_edge": 10.38
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 8.55,
                "warning_bottom_edge": 4.91,
                "warning_top_edge": 10.38
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 7.51,
                "warning_bottom_edge": 4.91,
                "warning_top_edge": 10.38
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 15.17,
                "warning_bottom_edge": 4.91,
                "warning_top_edge": 10.38
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 7.66,
                "warning_bottom_edge": 4.91,
                "warning_top_edge": 10.38
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 7.29,
                "warning_bottom_edge": 4.91,
                "warning_top_edge": 10.38
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 8.41,
                "warning_bottom_edge": 4.91,
                "warning_top_edge": 10.38
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 8.23,
                "warning_bottom_edge": 4.91,
                "warning_top_edge": 10.38
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 9.31,
                "warning_bottom_edge": 4.91,
                "warning_top_edge": 10.38
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 12.44,
                "warning_bottom_edge": 4.91,
                "warning_top_edge": 10.38
            }
        ]
    },
    "Лимфоциты (LYM %)": {
        "units": "%",
        "values": [
            {
                "panel_id": 10002,
                "made_at": "2017-03-28T00:00:00Z",
                "value": 23.59,
                "warning_bottom_edge": 20.11,
                "warning_top_edge": 46.79
            },
            {
                "panel_id": 10003,
                "made_at": "2017-04-04T00:00:00Z",
                "value": 23.39,
                "warning_bottom_edge": 20.11,
                "warning_top_edge": 46.79
            },
            {
                "panel_id": 10004,
                "made_at": "2017-06-24T00:00:00Z",
                "value": 27.02,
                "warning_bottom_edge": 20.11,
                "warning_top_edge": 46.79
            },
            {
                "panel_id": 10005,
                "made_at": "2017-08-29T00:00:00Z",
                "value": 37.29,
                "warning_bottom_edge": 20.11,
                "warning_top_edge": 46.79
            },
            {
                "panel_id": 10006,
                "made_at": "2017-11-21T00:00:00Z",
                "value": 33.39,
                "warning_bottom_edge": 20.11,
                "warning_top_edge": 46.79
            },
            {
                "panel_id": 10008,
                "made_at": "2018-03-07T00:00:00Z",
                "value": 69.62,
                "warning_bottom_edge": 20.11,
                "warning_top_edge": 46.79
            },
            {
                "panel_id": 10013,
                "made_at": "2018-06-01T00:00:00Z",
                "value": 67.56,
                "warning_bottom_edge": 20.11,
                "warning_top_edge": 46.79
            },
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 41.94,
                "warning_bottom_edge": 20.11,
                "warning_top_edge": 46.79
            },
            {
                "panel_id": 10016,
                "made_at": "2018-10-14T00:00:00Z",
                "value": 40.05,
                "warning_bottom_edge": 20.11,
                "warning_top_edge": 46.79
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 38.11,
                "warning_bottom_edge": 20.11,
                "warning_top_edge": 46.79
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 35.91,
                "warning_bottom_edge": 20.11,
                "warning_top_edge": 46.79
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 21.53,
                "warning_bottom_edge": 20.11,
                "warning_top_edge": 46.79
            }
        ]
    },
    "СОЭ": {
        "units": "мм/ч",
        "values": [
            {
                "panel_id": 10014,
                "made_at": "2018-06-18T00:00:00Z",
                "value": 8.58,
                "warning_bottom_edge": 2,
                "warning_top_edge": 20
            },
            {
                "panel_id": 10017,
                "made_at": "2018-11-17T00:00:00Z",
                "value": 10.85,
                "warning_bottom_edge": 2,
                "warning_top_edge": 20
            },
            {
                "panel_id": 10018,
                "made_at": "2018-12-15T00:00:00Z",
                "value": 18.01,
                "warning_bottom_edge": 2,
                "warning_top_edge": 20
            },
            {
                "panel_id": 10019,
                "made_at": "2018-12-26T00:00:00Z",
                "value": 5.83,
                "warning_bottom_edge": 2,
                "warning_top_edge": 20
            }
        ]
    },
}
